export function formatNumber(n, isDecimal = true, decimalLength = 2) {
  let x = Number(n);
  var parts = x.toFixed(decimalLength).split(".");
  var num = isDecimal
    ? parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + (parts[1] ? "." + parts[1] : "")
    : parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  return num;
}
